import { useMemo } from 'react';
import { useAaroQuery } from './useAaroQuery';
import {
    getOrderProductMovements,
    getOrders,
    getOrdersDetailed,
    getNotesBasic,
} from 'services/outside/aaro/aaroDekont';

export function useOrderQueries(params, options = {}) {
    const { id, type = 'DekontID', pageSize = 100, page = 1 } = params;

    const orderMovementsQuery = useAaroQuery({
        queryKey: ['orderMovements', id, type, page, pageSize],
        queryFn: () =>
            getOrderProductMovements({
                [type]: id,
                SayfaSatirSayisi: pageSize,
                SayfaNo: page,
            }),
        options: { ...options, requireSuccess: true },
    });

    const uniqueDekontIds = useMemo(() => {
        if (!orderMovementsQuery.data) return [];
        return [...new Set(orderMovementsQuery.data.map((item) => item.DekontID))];
    }, [orderMovementsQuery.data]);

    const orderDetailsQuery = useAaroQuery({
        queryKey: ['orderDetails', uniqueDekontIds, page, pageSize],
        queryFn: () =>
            getOrders({
                DekontID: uniqueDekontIds.join(','),
                SayfaSatirSayisi: pageSize,
                SayfaNo: page,
            }),
        options: { ...options, enabled: uniqueDekontIds.length > 0 },
    });

    const orderItemsQuery = useAaroQuery({
        queryKey: ['orderItems', id, type, page, pageSize],
        queryFn: () =>
            getOrdersDetailed({
                [type]: id,
                SayfaSatirSayisi: pageSize,
                SayfaNo: page,
            }),
        options: { ...options, requireSuccess: true },
    });

    const notesQuery = useAaroQuery({
        queryKey: ['orderNotes', id, type],
        queryFn: () => getNotesBasic({ TabloID: params.TabloID, TabloSatirID: params.TabloSatirID }),
        options: {
            ...options,
            requireSuccess: true,
        },
    });

    return {
        orderMovementsQuery,
        orderDetailsQuery,
        orderItemsQuery,
        uniqueDekontIds,
        notesQuery,
    };
}
